/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProcessStateSchema } from './ProcessStateSchema';
import {
    ProcessStateSchemaFromJSON,
    ProcessStateSchemaFromJSONTyped,
    ProcessStateSchemaToJSON,
} from './ProcessStateSchema';

/**
 * 
 * @export
 * @interface WorkerListSchema
 */
export interface WorkerListSchema {
    /**
     * 
     * @type {Date}
     * @memberof WorkerListSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkerListSchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkerListSchema
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof WorkerListSchema
     */
    id: number;
    /**
     * 
     * @type {ProcessStateSchema}
     * @memberof WorkerListSchema
     */
    currentState: ProcessStateSchema;
}

/**
 * Check if a given object implements the WorkerListSchema interface.
 */
export function instanceOfWorkerListSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "currentState" in value;

    return isInstance;
}

export function WorkerListSchemaFromJSON(json: any): WorkerListSchema {
    return WorkerListSchemaFromJSONTyped(json, false);
}

export function WorkerListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkerListSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'name': json['name'],
        'id': json['id'],
        'currentState': ProcessStateSchemaFromJSON(json['current_state']),
    };
}

export function WorkerListSchemaToJSON(value?: WorkerListSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'name': value.name,
        'id': value.id,
        'current_state': ProcessStateSchemaToJSON(value.currentState),
    };
}

